export default {
  DONE: "DONE",
  IN_PROGRESS: "IN_PROGRESS",
};
